module.exports = __webpack_public_path__ + "img/social_media_douyin.134e7d37.png";